module.exports = __webpack_public_path__ + "static/media/cycling.4dfbb413.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/cycling.svg
// module id = 371
// module chunks = 7